<template>
  <v-row class="clearfix padding-top-large padding-bottom-xlarge padding-left-small header">
    ErrorPage 
  </v-row>
</template>
<script>
export default {
  name: 'ErrorPage',
  components: {
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>
</style>